module.exports = __webpack_public_path__ + "img/product8.27ec275c.png";